import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M10.13 6.581c.474-2.016 3.324-2.07 3.875-.074l2.407 8.726 2.18-2.998A3 3 0 0 1 21.018 11H22a1 1 0 1 1 0 2h-.982a1 1 0 0 0-.808.412l-2.18 2.998c-.986 1.354-3.1.97-3.546-.645l-2.407-8.726-2.522 10.718c-.416 1.767-2.782 2.11-3.683.534l-2.164-3.787A1 1 0 0 0 2.839 14H2a1 1 0 1 1 0-2h.84a3 3 0 0 1 2.604 1.511L7.608 17.3z",
      clipRule: "evenodd"
    }
  )
);
var SvgSoundwaveOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var SoundwaveOutlined_default = SvgSoundwaveOutlined;

export { SoundwaveOutlined_default as default };
